/* unplugin-vue-components disabled */import { render } from "./svgIcon.vue?vue&type=template&id=b1df7a6a&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"

import "./svgIcon.vue?vue&type=style&index=0&id=b1df7a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1df7a6a"]])

export default __exports__